export enum TipoImportacaoDWEnum {

  AgrupaCreditoAReceber,
  FatoGeradorNFe,
  Geral
}
